import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon-collect-boutique.png'
import _imports_1 from '@/assets/image/icon/eye-jin.png'


const _withScopeId = n => (_pushScopeId("data-v-6239c710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-graphics-info" }
const _hoisted_2 = { class: "video-top-label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-mask" }, null, -1))
const _hoisted_4 = { class: "video-title" }
const _hoisted_5 = { class: "video-info" }
const _hoisted_6 = {
  key: 0,
  class: "video-boutique-box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "collect",
  src: _imports_0
}, null, -1))
const _hoisted_8 = { class: "video-author-name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "course-icon-clicks",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "video-clicks" }


import MImage from '@/components/MImage/MImage.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoListCard',
  props: {
  data: {},
  type: {
    type: Number,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter()



const jumpToSamllVideo = (data: any) => {
  const id = data?.id
  if (data?.type === 2) router.push(`/video/chosen/${id}?type=${props.type}`)
  else if (data?.type === 1)
    router.push(`/video/small/${id}?type=${props.type}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (jumpToSamllVideo(__props.data)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MImage, {
        class: "video-cover",
        src: __props.data.coverMapUrl,
        alt: "商品"
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.data.smallVideoTypeName || ''), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.smallVideoTitle), 1),
    _createElementVNode("div", _hoisted_5, [
      (props.type === 'boutique')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(__props.data.likeCount), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(MImage, {
              src: __props.data.headImg,
              alt: "",
              class: "video-author-avatar",
              type: "avatar"
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.data.userName), 1),
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(__props.data.views), 1)
          ], 64))
    ])
  ]))
}
}

})